// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import React, { ReactElement } from 'react';
import Editor from 'react-markdown-editor-lite';

interface PluginQuoteProps {
    editor: Editor;
}

export const PluginQuote = ({ editor }: PluginQuoteProps): ReactElement => {
    return (
        <span
            className="button"
            onClick={() => {
                const { text } = editor.getSelection();

                const newText = text
                    .split('\n')
                    .map((line) => `> ${line}`)
                    .join('\n');

                editor.insertText(newText, true);
            }}
        >
            <ICONS.QuoteRight />
        </span>
    );
};

PluginQuote.align = 'left';
PluginQuote.pluginName = 'quote';
